/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ "./src/js/components/accordion.js":
      /*!****************************************!*\
  !*** ./src/js/components/accordion.js ***!
  \****************************************/
      /***/ () => {
        eval(
          '$(document).on("click", ".accordion__trigger", function (event) {\n  event.preventDefault();\n  let accordionItem = $(this).closest(".accordion__item");\n  if (accordionItem.hasClass("open") == false) {\n    accordionItem.addClass("open");\n    accordionItem.find(".accordion__content").slideToggle("500");\n  } else {\n    accordionItem.removeClass("open");\n    accordionItem.find(".accordion__content").slideToggle("500");\n  }\n});\n//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvanMvY29tcG9uZW50cy9hY2NvcmRpb24uanMiLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsInNvdXJjZXMiOlsid2VicGFjazovL2xlYXJuLXdlYnBhY2svLi9zcmMvanMvY29tcG9uZW50cy9hY2NvcmRpb24uanM/YzMzMCJdLCJzb3VyY2VzQ29udGVudCI6WyIkKGRvY3VtZW50KS5vbihcImNsaWNrXCIsIFwiLmFjY29yZGlvbl9fdHJpZ2dlclwiLCBmdW5jdGlvbiAoZXZlbnQpIHtcbiAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcbiAgbGV0IGFjY29yZGlvbkl0ZW0gPSAkKHRoaXMpLmNsb3Nlc3QoXCIuYWNjb3JkaW9uX19pdGVtXCIpO1xuICBpZiAoYWNjb3JkaW9uSXRlbS5oYXNDbGFzcyhcIm9wZW5cIikgPT0gZmFsc2UpIHtcbiAgICBhY2NvcmRpb25JdGVtLmFkZENsYXNzKFwib3BlblwiKTtcbiAgICBhY2NvcmRpb25JdGVtLmZpbmQoXCIuYWNjb3JkaW9uX19jb250ZW50XCIpLnNsaWRlVG9nZ2xlKFwiNTAwXCIpO1xuICB9IGVsc2Uge1xuICAgIGFjY29yZGlvbkl0ZW0ucmVtb3ZlQ2xhc3MoXCJvcGVuXCIpO1xuICAgIGFjY29yZGlvbkl0ZW0uZmluZChcIi5hY2NvcmRpb25fX2NvbnRlbnRcIikuc2xpZGVUb2dnbGUoXCI1MDBcIik7XG4gIH1cbn0pO1xuIl0sIm5hbWVzIjpbXSwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///./src/js/components/accordion.js\n'
        );

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module can't be inlined because the eval-source-map devtool is used.
  /******/ var __webpack_exports__ = {};
  /******/ __webpack_modules__["./src/js/components/accordion.js"]();
  /******/
  /******/
})();
